import React, { useEffect, useState, useCallback } from "react";
import { Switch, Route } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Affix, Button } from "antd";

import AddressMeters from "./containers/AddressMeters/AddressMeters";
import AddressList from "./containers/AddressList/AddressList";
import NewMeter from "./containers/NewMeter/NewMeter";
import DownloadReport from "./components/DownloadReport/DownloadReport";
import UploadReport from "./components/UploadReport/UploadReport";
import getMeterTypes from "./store/thunks/getMeterTypes";
import appSettings from "../../constants/app.constants";
import getAllAddresses from "./requests/getAllAddresses";
import getTags from "./store/thunks/getTags";
import "./container.scss";

const MeterContainer = () => {
	const [height, setHeight] = useState(0);
	const [modalIsOpened, setModalOpened] = useState(false);

	const listener = useCallback(() => {
		setHeight(window.innerHeight - appSettings.windowHeightDelta);
	}, [window.innerHeight, appSettings.windowHeightDelta]);

	useEffect(() => {
		setHeight(window.innerHeight - appSettings.windowHeightDelta);
		window.addEventListener("resize", listener);

		return () => {
			window.removeEventListener("resize", listener);
		};
	}, []);

	const dispatch = useDispatch();
	useEffect(() => {
		(async () => {
			await dispatch(getTags());
			await dispatch(getMeterTypes());
			await dispatch(getAllAddresses());
		})();
	}, []);
	const openModal = useCallback(() => setModalOpened(true), []);
	const closeModal = useCallback(() => setModalOpened(false), []);

	return (
		<>
			<Affix
				className="dispex-filter-button"
				offsetTop={10}
				style={{ zIndex: 15 }}
			>
				<div>
					<Button
						className="file-button file-button-transparent"
						onClick={openModal}
					>
						Выгрузить показания
					</Button>
					<UploadReport />
				</div>
				
			</Affix>
			<div className="meter-container" style={{ height }}>
				{modalIsOpened && (
					<DownloadReport
						modalIsOpened={modalIsOpened}
						openModal={openModal}
						closeModal={closeModal}
					/>
				)}
				<div className="meter-left-block">
					<AddressList height={height} />
				</div>
				<div className="meter-right-block">
					<Switch>
						<Route path="/Meters/address/:id">
							<AddressMeters />
						</Route>
						<Route path={"/Meters/newMeter"}>
							<NewMeter />
						</Route>
					</Switch>
				</div>
			</div>
		</>
	);
};

export default MeterContainer;
